module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/selector/asset/arrow-down.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/selector/asset/arrow-down.png
// module id = 1080
// module chunks = 418